export type DashboardPeriod = 'gunluk' | 'dun' | 'aylik' | 'yillik' | 'ozel';

export interface DonemSecenegi<P extends string> {
  key: P;
  label: string;
}

const OPTIONS: ReadonlyArray<DonemSecenegi<DashboardPeriod>> = [
  { key: 'gunluk', label: 'Günlük' },
  { key: 'dun', label: 'Dün' },
  { key: 'aylik', label: 'Aylık' },
  { key: 'yillik', label: 'Yıllık' },
  { key: 'ozel', label: 'Özel' },
];

interface PeriodTabsProps<P extends string> {
  value: P;
  onChange: (p: P) => void;
  /**
   * Sekme listesi. Verilmezse Ozet sayfasinin bes sekmesi — DynamicDashboard bu prop'u GECMEZ ve
   * davranisi degismez. Satis Analiz "Bu hafta"yi kendi listesiyle ekler (G2/K3).
   */
  secenekler?: ReadonlyArray<DonemSecenegi<P>>;
}

export function PeriodTabs<P extends string = DashboardPeriod>({ value, onChange, secenekler }: PeriodTabsProps<P>) {
  // `secenekler` yoksa cagiran DashboardPeriod ile cagiriyordur (P = DashboardPeriod).
  const liste = secenekler ?? (OPTIONS as unknown as ReadonlyArray<DonemSecenegi<P>>);
  return (
    <div className="inline-flex rounded-lg border border-border bg-surface2 p-0.5" role="tablist" data-testid="period-tabs">
      {liste.map((o) => (
        <button
          key={o.key}
          type="button"
          role="tab"
          aria-selected={value === o.key}
          onClick={() => onChange(o.key)}
          className={
            'px-4 py-1.5 text-sm font-medium rounded-md transition-colors ' +
            (value === o.key
              ? 'bg-surface text-text shadow-sm'
              : 'text-muted hover:text-text')
          }
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
